import { render, staticRenderFns } from "./apiDash.vue?vue&type=template&id=0dbc53ad&scoped=true"
import script from "./apiDash.vue?vue&type=script&lang=js"
export * from "./apiDash.vue?vue&type=script&lang=js"
import style0 from "./apiDash.vue?vue&type=style&index=0&id=0dbc53ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbc53ad",
  null
  
)

export default component.exports